module.exports = __webpack_public_path__ + "static/media/The Fidelio Duetto.a53e794c.png";